import { useMemo } from "react";

import { resolveWearablePathDefaults } from "@/lib/wearables/wearables.pathDefaults";
import { useWearablesStore } from "@/state/wearables/useWearablesStore";

import { useWearableProfileBridge } from "./useWearableProfileBridge";

export function useWearablePathAwareDefaults() {
  const wearableProfileBridge = useWearableProfileBridge();
  const onboardingTrack = useWearablesStore((state) => state.onboardingTrack);
  const identityBaseline = useWearablesStore((state) => state.identityBaseline);

  return useMemo(
    () =>
      resolveWearablePathDefaults({
        bridge: wearableProfileBridge ?? undefined,
        baseline: identityBaseline ?? undefined,
        onboardingTrack,
      }),
    [wearableProfileBridge, identityBaseline, onboardingTrack],
  );
}

export default useWearablePathAwareDefaults;